import React from 'react'
import PieChartDevice from '../Chart/PieChartDevice'
import { Card } from 'antd'
import { COLORS } from '../../constant';
import EmptyData from '../common/EmptyData';

function NumberUserActivePlatform({
  data,
  loading
}: {
  data: number; // total active users as a number
  loading?: boolean;
}) {
  const totalUsers = data || 0;

  const dataPrimary = {
    labels: ["website"],
    datasets: [
      {
        label: '',
        data: [totalUsers],
        backgroundColor: COLORS.slice(0, 1), // only one slice
      },
    ],
  };

  return (
    <Card className='shadow-md h-[480px] w-full' title="Number of active users by platform">
      <div className='max-h-[380px] w-full flex justify-center'>
        {totalUsers > 0 ? (
          <PieChartDevice data={dataPrimary} />
        ) : (
          <EmptyData type='' />
        )}
      </div>
    </Card>
  )
}

export default NumberUserActivePlatform